export default __webpack_public_path__ + "static/media/stellar-cyber-logo-2023.b3f5fd5c.svg";